import { Controller } from '@hotwired/stimulus'
// import * as filestack from 'filestack-js'
import { headers } from '../../src/js/csrf'

export default class extends Controller {
  static targets = [ 'attachments', 'attachment' ]

  initialize() {
    import('filestack-js').then(filestack => {
      this.filestack = filestack
    })
  }

  // called manually to properly pass the options
  initFilestack(event) {
    this.apikey = 'ActYCootWSCGTbMNzaGinz'
    this.security = {
      policy: this.data.get('policy'),
      signature: this.data.get('signature')
    }
    this.client = this.filestack.init(this.apikey, {security: this.security})
    // default options
    // any value can be overridden from other controller
    const defaultOptions = {
      accept: ['image/jpeg', 'image/jpg', 'image/png', 'audio/*', 'video/*'],
      maxFiles: 15,
      maxSize: 4000000000,
      fromSources: ['local_file_system', 'googledrive', 'instagram', 'dropbox', 'onedrive', 'webcam'],
      storeTo: {
        access: 'public',
        location: 's3',
        path: '/development/' // should be rewritten
      },
      transformations: {
        circle: false,
        crop: false,
      },
      uploadInBackground: true,
      // onFileUploadProgress: this._onFileUploadProgressCallback.bind(this),
      onFileUploadFinished: this._onFileUploadFinishedCallback.bind(this),
      onUploadStarted: this._onUploadStartedCallback.bind(this),
      onFileSelected: this._onFileSelectedCallback.bind(this)
    }
    const resultOptions = {...defaultOptions, ...event.detail}
    this.picker = this.client.picker(resultOptions)
  }

  openFilestack() {
    this.picker.open()
  }

  _onFileUploadProgressCallback(file, event) {
    // this.progressBarTarget.parentElement.classList.remove('d-none')
    // let value = event.totalPercent / 100
    console.log(event.totalPercent)
    // this.bar.animate(value) // Number from 0.0 to 1.0
  }

  _onFileUploadFinishedCallback(data) {
    const { filename, handle, size, mimetype, type, key } = data
    // to remove extension and other dots
    // let filename = data.filename.split('.').slice(0, -1).join('_')
    fetch('/attachments', {
      method: 'post',
      headers: headers,
      body: JSON.stringify({
        attachment: {
          file_name: filename,
          handle: handle,
          file_size: size,
          file_type: mimetype || type,
          s3_key: key,
        }
      })
    }).then(response => {
      if (!response.ok) { throw response } // moving flow to catch block
      return response.json()
    }).then(res => {
      this.appendAttachment(res)
      // TODO: check if thumb already exist
      if (mimetype.includes('video')) {
        this.transformVideo(handle, filename)
      }
    }).catch(error => console.error("we got an error: ", error))
  }

  _onUploadStartedCallback() {
    // show attachments only after upload button clicked
    this.uploadClicked = true
    this.attachmentTargets.forEach((att) => {
      att.classList.remove('d-none')
    })
  }

  appendAttachment(res) {
    // hide attachment until upload button clicked
    // only if 'Upload' is not clicked
    if (this.uploadClicked) {
      this.attachmentsTarget.insertAdjacentHTML('beforeend', res.html)
    } else {
      const parser = new DOMParser()
      const full = parser.parseFromString(res.html, 'text/html')
      const attachment = full.querySelector("[data-target~='filestack.attachment']")
      attachment.classList.add('d-none')
      this.attachmentsTarget.append(attachment)
    }
  }

  transformVideo(handle, filename) {
    const filelink = new this.filestack.Filelink(handle, this.apikey)
    const convertlink = filelink.security(this.security).videoConvert({clip_length: '00:00:04'}).toString()
    const checkConvStatus = () => {
      fetch(convertlink)
        .then(response => {
          if (!response.ok) { throw response } // moving flow to catch block
          return response.json()
        }).then(res => {
        if (res.status === 'completed') {
          this.processTransformed(res, handle, filename)
        } else {
          setTimeout(checkConvStatus, 2000)
        }
      }).catch(err => console.error('we got an error: ', err))
    }
    setTimeout(checkConvStatus, 2000)
  }

  // taking json info of converted video and handle
  processTransformed(res, handle, filename) {
    // result of short converted video is not used yet
    // let handleNew = this.extractHandle(res.data.url)
    // let convertedLink = this.createSecureLink(handleNew)
    const handleThumb = this.extractHandle(res.data.thumb)
    const thumbUrl = this.createSecureLink(handleThumb)
    this.appendThumb(thumbUrl, handle)
    this.storeThumb(handleThumb, filename)
  }

  /**
   *
   * @param str
   * @returns {*|string} handle extracted from insecure link
   */
  extractHandle(str) {
    const splitArray = str.split('/')
    return splitArray[splitArray.length - 1]
  }

  /**
   *
   * @param handle
   * @returns {string} secure url created from handle
   */
  createSecureLink(handle) {
    return new this.filestack.Filelink(handle, this.apikey).security(this.security).toString()
  }

  appendThumb(thumbUrl, handle) {
    this.attachmentTargets.forEach((attachment) => {
      if (attachment.dataset.handle === handle) {
        attachment.querySelector('img').src = thumbUrl
      }
    })
  }

  storeThumb(handleThumb, filename) {
    const filenameSplit = filename.split('.')
    const last = filenameSplit.pop()
    const filelink = new this.filestack.Filelink(handleThumb, this.apikey)
    const storelink = filelink.security(this.security).store({
      filename: `${filenameSplit}_vid_thumb.${last}`,
      location: 's3',
      path: this.data.get('env') === 'production' ? '/video_thumb/' : '/development/',
      access: 'public'
    }).toString()
    fetch(storelink)
      .then(response => {
        if (!response.ok) { throw response } // moving flow to catch block
        return response.json()
      }).then(data => {
        this.saveThumb(data)
      }).catch(err => console.error('we got an error', err))

    // this.client.retrieve(handleThumb, {metadata: true}, this.security)
    //   .then(res => this.saveThumb(res, handleThumb))
  }

  saveThumb(data) {
    const { filename, handle, size, mimetype, type, key } = data
    fetch('/attachments', {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({
        attachment: {
          file_name: filename,
          handle: handle,
          file_size: size,
          file_type: mimetype || type,
          s3_key: key,
          purpose: 'vid_thumb'
        }
      })
    }).then(response => {
      if (!response.ok) throw response // moving flow to catch block
      return response.json()
    }).catch(err => console.error('we got an error: ', err))
  }

  // callback
  // to reset uploadClicked
  _onFileSelectedCallback() {
    this.uploadClicked = false
  }

}
